import { Component } from 'react';
import { Nav } from './Nav';
import { Footer } from './Footer';
import { Seo } from './Seo';

export default class PageErrorBoundary extends Component {
  state = { failed:false };
  static getDerivedStateFromError() { return {failed:true}; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="jmh-public-layout min-h-screen"><Nav /><main className="jmh-public-main jmh-page-center text-center" id="main-content"><Seo title="Page unavailable" noindex /><h1 className="font-display gold-text">We couldn’t open this page.</h1><p>Please reload the page, or return to the homepage.</p><button className="jmh-cta" onClick={() => window.location.reload()}>Reload page</button><a className="jmh-cta" href="/">Return Home</a></main><Footer /></div>;
  }
}
